import { ToolUIPart } from 'ai';

import CollapsibleContent from '../../CollapsibleContent';

import { createSummaryTitle } from './summary-titles';

import { PathwayUITools } from '@/routes/smart-search/types';

interface ToolSummaryProps {
  part: ToolUIPart<PathwayUITools>;
}

const ToolSummary: React.FC<ToolSummaryProps> = ({ part }) => (
  <CollapsibleContent
    title={createSummaryTitle(part)}
    error={['output-error', 'output-denied'].includes(part.state)}
  >
    {part.state === 'output-error' ? (
      <p className="my-2 text-sm text-gray-600">{part.errorText}</p>
    ) : (
      <p className="my-2s text-sm text-gray-600">
        {JSON.stringify(part.output)}
      </p>
    )}
  </CollapsibleContent>
);

export default ToolSummary;
